module.exports = __webpack_public_path__ + "img/logo_svg.7449243a.png";